import { render, staticRenderFns } from "./NotificationSettingsSendingSettings.vue?vue&type=template&id=98b19690"
import script from "./NotificationSettingsSendingSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsSendingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports